import { render, staticRenderFns } from "./ProductItemfour.vue?vue&type=template&id=31001577&scoped=true"
import script from "./ProductItemfour.vue?vue&type=script&lang=js"
export * from "./ProductItemfour.vue?vue&type=script&lang=js"
import style0 from "./ProductItemfour.vue?vue&type=style&index=0&id=31001577&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31001577",
  null
  
)

export default component.exports